import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {Button} from "@mui/material";
import GlobalConst from "../../../../../constants/GlobalConst";
import ProductItemsMobile from "./ProductItemsMobile";
import ProductItems from "./ProductItems";
import {_t} from "../../../../../utils/I18nUtils";
import tradefanApi  from "../../../../../stores/tradefan/tradefan.api";
import "./ProductSelection.scss";
import {useDispatch} from "react-redux";
import {triggerEventAsync} from "../../../../../stores/marketing/marketing.thunks";
import BetContextModule from "../BetContextModule/BetContextModule";

const ProductSelection = ({vm, parlayContext}) => {

    const dispatch = useDispatch();
    const [hasUsedPromo, setHasUsedPromo] = useState(false);
    const [hasReceivedFirstTimeUsdDepositBonus, setHasReceivedFirstTimeUsdDepositBonus] = useState(false);
    const [hasReceivedFirstTimeMxnDepositBonus, setHasReceivedFirstTimeMxnDepositBonus] = useState(false);

    useEffect(() => {
        const fetchPromoStatus = async () => {
            let res = await dispatch(tradefanApi.endpoints.getHasReceivedDepositBonus.initiate(undefined, {
                forceRefetch: true,
            }));
            setHasUsedPromo(res.data);

            let mxRes = await dispatch(tradefanApi.endpoints.getHasReceivedFirstTimeMxnDepositBonus.initiate(undefined, {
                forceRefetch: true,
            }));
            setHasReceivedFirstTimeMxnDepositBonus(mxRes.data);
            let usdRes = await dispatch(tradefanApi.endpoints.getHasReceivedFirstTimeUsdDepositBonus.initiate(undefined, {
                forceRefetch: true,
            }));
            setHasReceivedFirstTimeUsdDepositBonus(usdRes.data);
        };
        fetchPromoStatus();
    }, []);

    const isMobile = window.innerWidth < 768;

    const showFirstTimeDepositMxnPromoOffers = GlobalConst.FEATURES.SHOW_FIRSTTIMEDEPOSIT_MXN_PROMO_OFFERS && !hasReceivedFirstTimeMxnDepositBonus;
    const showFirstTimeDepositUsdPromoOffers = GlobalConst.FEATURES.SHOW_FIRSTTIMEDEPOSIT_USD_PROMO_OFFERS && !hasReceivedFirstTimeUsdDepositBonus;

    return <div className="ProductSelection">
        <h2 className="secureDeposit">
            {_t(`popUp.secureDeposit.title`)}
        </h2>
        {(showFirstTimeDepositMxnPromoOffers || showFirstTimeDepositUsdPromoOffers) && <div className="limitedOffer">
            <div className="offerMain">
                <b>{_t(`views.addFundView.limitedTimeOfferFTDMXNDetails`, {amount: Math.min(vm.selectedProduct?.price ?? 0, GlobalConst.PROMO.DOUBLE_DEPOSIT.AMOUNT)})}</b>
            </div>
            <em className="offerSub">{_t(`views.addFundView.noComplicatedTerms`)}</em>
        </div>}

        <p className="selectAmountText">{_t(`views.addFundView.chooseAmount`)} {`(${GlobalConst.CURRENCIES_ABBR[GlobalConst.SITE_CURRENCY]})`}</p>
        {isMobile ? <ProductItemsMobile vm={vm}
                                        products={vm.products}
                                        onProductSelected={p => vm.onProductSelected(p)}
                                        hasUsedPromo={hasUsedPromo}/>
                :  <ProductItems vm={vm}
                                 products={vm.products}
                                 onProductSelected={p => vm.onProductSelected(p)}
                                 hasUsedPromo={hasUsedPromo}
            />
        }
        {parlayContext?.inParlay && (
            <BetContextModule
                potentialPayout={parlayContext.potentialPayout}
                currency={parlayContext.currency}
            />
        )}
        <div className="buttonsBar">
            <Button
                onClick={() => vm.handleProductionSelectionSubmitClick()}
                className="addFundsButton"
                disabled={!vm.selectedProduct || parseFloat(vm.selectedProduct.price) < GlobalConst.MIN_DEPOSIT_FUNDS}
            >
                <FormattedMessage id={"popUp.secureDeposit.addFunds"}/>
            </Button>
        </div>
        <div className="trustModule">
            <span>{_t(`views.addFundView.trustSecure`)}</span>
            <span className="separator">·</span>
            <span>{_t(`views.addFundView.trustFast`)}</span>
            <span className="separator">·</span>
            <span>{_t(`views.addFundView.trustEasy`)}</span>
        </div>
    </div>;
};

ProductSelection.propTypes = {
    t: PropTypes.func,
    vm: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
    parlayContext: PropTypes.shape({
        inParlay: PropTypes.bool,
        potentialPayout: PropTypes.number,
        currency: PropTypes.string,
    }),
}
export default ProductSelection;